function closeMenu() {
    let toggleInput = document.getElementById('navbar-collapse');
    toggleInput.checked = false;
}

export default closeMenu